import React from "react";
import { Typography, useTheme } from "@mui/material";
import SimpleBox from "../../components/layout/container/SimpleBox";

const LegalSection = ({ title, children }) => {
    const theme = useTheme();
    return (
        <SimpleBox fullWidth={true} flexDirection="column" alignItems="left" mt={4}>
            <Typography gutterBottom variant="h4">{title}</Typography>
            {children}
        </SimpleBox>
    );
}

export default LegalSection;
